import { Guid } from "guid-typescript";
import { extend } from "lodash";
export class PagingParams {
  pageNumber: number;
  pageSize: number;
  orderBy: string;
  sortingOrder: string;
}
export class GetCampaignOptions extends PagingParams {
  profileId: number;
  startDate: string;
  endDate: string;
  eventType: string;
  calendarEventType: string; //_allEvent, _acceptedEvent
  searchText: string;
  venueText: string;
  categories: number[];
  distance: number;
}
export enum campaignsListTableTabs {
  ALL = 'all',
  SCHEDULED = 'scheduled',
  TRASH = 'trash',
  DRAFT = 'draft',
  PUBLISHED = 'published',
}
export enum campaignsIdeaTableTabs {
  RECOMMENDATIONS = '_generated',
  FAVORITES = '_favorites',
  COMPLETED = '_completed',
  DISMISSED = '_dismissed'
}
export enum KeywordConstraint {
  MAX_KEYWORDS = 6
}
export interface CampaignPayloadDataType {
  campaignDetails: CampaignDetails;
  language: string;
  tone: string;
  contentBrief: string;
  gender: string;
  ageGroup: string;
  interestAndPersona: string;
  brandVoiceDocument: string;
  isOutlineCreation: boolean;
  isGenericFlow: boolean;
  templateId: number;
  templateTitle: string;
  inputText: string;
  titleText: string;
  placeholderText: string;
  contentBriefText: string;
  isPublishable: boolean;
}

export class CampaignDetails {
  _id: string;
  campaignName: string;
  description: string;
  useCase: string;
  goal: string;
  keywords: string[];
  campaignBrief: string;

  constructor() {
    this._id = '';
    this.campaignName = '';
    this.description = '';
    this.useCase = '';
    this.goal = '';
    this.keywords = [];
    this.campaignBrief = '';
  }
}


// event.model.ts
export interface Event {
  event: string;
  date: string;
  color: string;
  type: string;
}
export class GetMyCampaignsRequest extends PagingParams {
  profileId: number;
  search?: string;
  pageNumber: number;
  pageSize: number;
  orderBy: string;
  sortingOrder: string;
  campaignIds: string[];
  status?: string;
  objectives?: string[];
  createdby?: number;
  startDate?: Date;
  endDate?: Date;
  dateRangeType?: string;
}
export class GetMyCampaignsResponse {
  totalRecord: number;
  campaigns: Campaign[];
  errorCode?: number;
  message: string;
  success: boolean;
}
export class Campaign {
  _id: string;
  brandId: string;
  profileId: number;
  description: string;
  campaignName: string;
  useCase: string[];
  goal: string;
  campaignGoal: string;
  status: string;
  campaignType: string;
  keywords: string[];
  campaignBrief: string;
  eventDate: Date;
  eventEndDate: Date;
  isUsed?: boolean;
  createdBy: number;
  createdDate?: Date;
  updatedBy: number;
  lastUpdatedDate?: Date;
  brandVoiceId: number;
  targetAudienceId: number;
  urls:string[];
  isIndividualUrls:boolean;
  createdByName:string= "";
  associatedArticlesCount: number;
  draftededArticlesCount: number;
  publishedArticlesCount: number;
  address?: string = '';
  telephoneNumber?: string = '';
}
export class GetCampaignsEventsRequest {
  profileId?: number;
  month?: number;
  year?: number;
}
export class GetCampaignsEventsResponse {
  isCampaignsIdeasOrEventGenerated: boolean;
  campaignsEvents: Campaign[];
  errorCode?: number;
  message: string;
  success: boolean;
}
export class GetCampaignsIdeasRequest extends PagingParams {
  profileId: number;
  status: string;
  goal: string;
  search: string;
  pageNumber: number;
  pageSize: number;
  orderBy: string;
  sortingOrder: string;
}
export class GetCampaignsIdeasResponse {
  isCampaignsIdeasOrEventGenerated: boolean;
  totalRecord: number;
  campaignsIdeas: Campaign[];
  errorCode?: number;
  message: string;
  success: boolean;
}
export class CalenderEvents {
  campaignName: string;
  eventDate: Date;
  eventEndDate: Date;
  color: string;
  type: string;
  description: string;
  campaignBrief: string;
  goal: string;
}
export class UpdateCampaignStatusRequest {
  campaignId?: string;
  status: string;
}
export class UpdateCampaignStatusResponse {
  errorCode?: number;
  message: string;
  success: boolean;
}
export class DeleteCampaignRequest {
  campaignId: string;
}
export class DeleteCampaignResponse {
  errorCode?: number;
  message: string;
  success: boolean;
}

export class GenerateCampaignsFromAIResponse {
  errorCode?: number;
  message: string;
  success: boolean;
}

export class Goal {
  title: string;
  icon: string;
  iconColor: string;
  description: string;
  isSelectedGoal: boolean
}

export class RenameCampaignRequest {
  campaignId: string;
  campaignNewName: string;
  constructor(campaignId: string, campaignNewName: string) {
    this.campaignId = campaignId;
    this.campaignNewName = campaignNewName;
  }
}

export class RenameCampaignResponse {
  errorCode?: number;
  message: string;
  success: boolean;
}

export interface AnalyzeUrlsRequest {
  urls: string[];
  keywords: string[];
  profileId: number;
  businessId: number;
  profileName: string;
  isIndividualUrls: boolean;
  brandId:string;
}

export class AnalyzeUrlsResponse {
  errorCode?: number;
  message: string;
  success: boolean;
  campaignId: string;
}
export class UploadInstDocsRequest {
  files: FileInfo[];
  //profileId: number;
  //campaignId: string;  
}
export class FileInfo {
  file: File;
  documentType: string = '';
  documentDescription: string = '';
}
export class UploadInstDocsResponse {
  errorCode?: number;
  message: string;
  success: boolean;
  documentDetailsResult: ContentInstructionDocument[];
}
export class ContentInstructionDocument {
  name: string = '';
  type: string = '';
  path: string = '';
}
export class UploadKeywordResponse {
  errorCode?: number;
  message: string;
  success: boolean;
  keywordData: string[];
  totalRecords: number;
  webpageKeywordMap: { [key: string]: string[] };
  totalWebpages: number;
  highlights: { [key: string]: string[] };
}

export class IsCampaignInProgressResponse {
  success: boolean;
  isInProgress: boolean;
  message: string;
}
export class UpdateProjectStatusRequest {
  profileId: number;
  projectIds: string[];
  actionName: string;
  userId: number;
}
export class UpdateProjectStatusResponse {
  errorCode?: number;
  message: string;
  success: boolean;
}

export class GetFiltersForMyCampaignsResponse {
  createByFilters?: CreateByFilter[];
  errorCode?: number;
  message: string;
  success: boolean;
}

export interface CreateByFilter {
  createdByName?: string | null;
  createdBy: number;
}

export class UploadKeywordDocumentResponse {
  errorCode?: number;
  message?: string;
  success: boolean;
  sampleFileUrl?: string;
  details?: KeywordDocumentValidationError[];
  data?: KeywordDocumentUploadData;
}

export class KeywordDocumentValidationError {
  sheet: string;
  issue: string;
}

export class KeywordDocumentUploadData {
  resources?: KeywordDocumentResources;
  keywords?: KeywordSheetRow[];
  highlights?: KeywordHighlightsSheetData;
  attractions?: KeywordAttractionsSheetData;
}

export class KeywordDocumentResources {
  hotelInformation?: KeywordHotelInformation;
  resources?: KeywordResourceUrls;
}

export class KeywordHotelInformation {
  name?: string;
  brand?: string;
  inncode?: string;
}

export class KeywordResourceUrls {
  questionnaireUrl?: string;
  webUrl?: string;
  googleMapsUrl?: string;
}

export class KeywordSheetRow {
  pageName?: string;
  keywordTarget?: string;
  keywords?: string[];
  competition?: string;
  searchVolume?: number;
}

export class KeywordHighlightsSheetData {
  boundTo?: string;
  items?: KeywordHighlightItem[];
}

export class KeywordHighlightItem {
  id?: number;
  name?: string;
  additionalInfo?: string;
}

export class KeywordAttractionsSheetData {
  boundTo?: string;
  items?: KeywordAttractionItem[];
}

export class KeywordAttractionItem {
  id?: number;
  name?: string;
  primaryKeyword?: KeywordDetail;
  secondaryKeyword?: KeywordDetail;
}

export class KeywordDetail {
  value?: string;
  competition?: string;
  searchVolume?: number;
}
